import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { VouchersService } from '../services/VouchersService';
import { IVoucherType } from '../interfaces/IVoucherType';

export const externalVouchersResolver: ResolveFn<IVoucherType[]> = () => {
  return inject(VouchersService).getExternalVouchers()
    .pipe(map(res => res.data));
};
